import React, { useState } from 'react';
import { Link } from '../../Link/Link';
import { MenuItem } from '../Header/interfaces';
import './MenuGroup.scss';

interface Props {
  item: MenuItem;
  onClickLink?: () => void;
  textClassName?: string;
}

/**
 * Пункт выпадашки со своими дочерними пунктами (третий уровень меню):
 * заголовок, галочка и свёрнутый список. Серверная шапка рисует ту же
 * разметку в dalli_menu_group_html (тема, core/menu.php).
 */
const MenuGroup = ({ item, onClickLink, textClassName }: Props) => {
  const [open, setOpen] = useState(false);
  const toggle = () => setOpen(!open);
  const hasUrl = !!item.url && item.url !== '#';

  return (
    <div className={`menu-group${open ? ' menu-group_open' : ''}`}>
      <div className="menu-group__head">
        {hasUrl ? (
          <Link to={item.url} className="menu-group__title" onClick={onClickLink}>
            <p className={textClassName} dangerouslySetInnerHTML={{ __html: item.title }}></p>
          </Link>
        ) : (
          <p
            className={`menu-group__title${textClassName ? ` ${textClassName}` : ''}`}
            onClick={toggle}
            dangerouslySetInnerHTML={{ __html: item.title }}
          ></p>
        )}
        <button
          type="button"
          className="menu-group__toggle"
          aria-expanded={open}
          aria-label={`Показать пункты раздела «${item.title}»`}
          onClick={toggle}
        />
      </div>

      <div className="menu-group__list">
        {(item.children || []).map(({ title, url }, i) => (
          <Link to={url} className="menu-group__link" key={i} onClick={onClickLink}>
            <p className={textClassName} dangerouslySetInnerHTML={{ __html: title }}></p>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default MenuGroup;
